// extracted by mini-css-extract-plugin
export default {"firstname-row":"personal-info_firstname-row__WwzWO","lastname-row":"personal-info_lastname-row__ZG45U"};